import { FormContainer } from "../../Components";
import * as yup from "yup";
import { ProfileType, UserInviteType } from "../../global/types/user";
import { useContext, useEffect, useState } from "react";
import { ApiGetProfiles, ApiSendInvite } from "../../services/api";
import { AlertContext } from "../../context/AlertContext";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Typography from "../../Components/Typography";
import {
  Field,
  FieldError,
  FieldGroup,
  FieldLabel,
} from "../../Components/ui/shadcn/forms/field";
import { Input } from "../../Components/ui/input";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../../Components/ui/shadcn/forms/select";

const inviteUserSchema = yup.object({
  email: yup
    .string()
    .email("Entre com um email válido")
    .required("O email é nescessário"),
  name: yup.string().required("Digite o nome do convidado"),
  profileId: yup.number().required("Selecione o perfil do convidado"),
});

export const InviteUser: React.FC = () => {
  const [profiles, setProfiles] = useState<ProfileType[]>([]);

  useEffect(() => {
    const getProfiles = async () => {
      try {
        const { content } = await ApiGetProfiles();
        setProfiles(content);
      } catch (error) {
        //   setAlertMessage('error', (error as Error).message);
      } finally {
      }
    };
    getProfiles();
  }, []);
  const { setAlertMessage } = useContext(AlertContext);

  const handleLogin = async (values: UserInviteType) => {
    try {
      const { message } = await ApiSendInvite(values);
      await setAlertMessage("success", message);
    } catch (error) {
      setAlertMessage("error", (error as Error).message);
    } finally {
    }
  };

  const form = useForm<UserInviteType>({
    defaultValues: {
      email: "",
      name: "",
      profileId: 0,
    },
    resolver: yupResolver(inviteUserSchema),
  });

  return (
    <FormContainer
      onSubmit={handleLogin}
      submitLabel="Cadastrar"
      methods={form}
    >
      <Typography variant="h4">Convite de Cadastro</Typography>
      <FieldGroup>
        <Controller
          name="name"
          control={form.control}
          render={({ field, fieldState }) => (
            <Field data-invalid={fieldState.invalid}>
              <FieldLabel htmlFor="form-invite-nome">Nome</FieldLabel>
              <Input
                {...field}
                id="form-invite-nome"
                aria-invalid={fieldState.invalid}
                placeholder="Digite o nome do convidado."
                autoComplete="off"
              />
              {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
            </Field>
          )}
        />
        <Controller
          name="email"
          control={form.control}
          render={({ field, fieldState }) => (
            <Field data-invalid={fieldState.invalid}>
              <FieldLabel htmlFor="form-invite-email">E-mail</FieldLabel>
              <Input
                {...field}
                id="form-invite-email"
                aria-invalid={fieldState.invalid}
                placeholder="abcdef@exemplo.com"
                autoComplete="off"
              />
              {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
            </Field>
          )}
        />
        <Controller
          name="profileId"
          control={form.control}
          render={({ field, fieldState }) => (
            <Field data-invalid={fieldState.invalid}>
              <FieldLabel htmlFor="form-invite-profile">Perfil</FieldLabel>
              <Select
                value={field.value ? field.value + "" : ""}
                onValueChange={(val) => field.onChange(Number(val))}
              >
                <SelectTrigger className="w-full max-w-48">
                  <SelectValue placeholder="Selecione o perfil do convidado" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel>Perfil</SelectLabel>
                    {profiles.map((profile) => (
                      <SelectItem key={profile.id} value={profile.id + ""}>
                        {profile.name}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
              {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
            </Field>
          )}
        />
      </FieldGroup>
    </FormContainer>
  );
};
